import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from "rxjs";
// import { LinkOptions } from '../interfaces/types';

import { environment } from "../../../environments/environment";

declare var bootstrap:any;

@Injectable({
  providedIn: "root"
})
export class CommonService {
  toastConfig: any = {
    maxOpened: 1,
    autoDismiss: true,
    // closeButton: true,
    tapToDismiss: true,
    progressBar: true,
    progressAnimation: "decreasing",
    // toastClass: 'toast-class',
    // messageClass: "toast-message",
    // containerId: 'toast-container',
    // debug: false,
    fadeIn: 300,
    fadeOut: 1000,
    extendedTimeOut: 1000,
    positionClass: "toast-top-center",
    timeOut: 5000, // Set timeOut to 0 to make it sticky
    theme: "bootstrap"
  };

  slideIndex = 0;
  slideWidth = 0;
  startX = 0;

  // Confirm Modal
  private modalResponse$ = new Subject<boolean>();
  private modal!: any;
  confirmModalTitle: string = 'Confirm';
  confirmOkText: string = 'OK';

  constructor(
    private location: Location,
    private router: Router,
    private toastr: ToastrService,
    private ngZone: NgZone,
  ) {}

  ngAfterViewInit() {
    
  }

  back() {
    this.location.back();
  }

  navigateTo(route: string, queryParams?: {[key: string]: any }) {
    if(queryParams) {
      this.router.navigate([`/${route}`], { queryParams: queryParams })
    } else {
      this.router.navigate([`/${route}`]);
    }
  }

  showToast(message: any, type: any) {
    const title: any = null;
    switch (type) {
      case "success":
        this.toastr.success(message, title, this.toastConfig);
        break;
      case "warning":
        this.toastr.warning(message, title, this.toastConfig);
        break;
      case "info":
        this.toastr.info(message, title, this.toastConfig);
        break;
      case "danger":
        this.toastr.error(message, title, this.toastConfig);
        break;

      default:
        this.toastr.info(message, title, this.toastConfig);
        break;
    }
  }

  shareText(text: string, title?: string): Promise<void> {
    if (!navigator.share) {
      this.showToast("Share API is not supported in this browser.","danger");
      return Promise.reject("Share API is not supported.");
    }

    return navigator.share({
      text: text,
      title: title || "Share Text"
    });
  }

  // linkifyText(text: string, options?: LinkOptions): string {
  //   // Default options
  //   const rootUrl = environment.rootUrl;
  //   const hashtagRootUrl = `${rootUrl}/hashtags`;
  //   const usernamePath = 'u';

  //   // Merge options with defaults
  //   const { rootUrl: customRootUrl, hashtagRootUrl: customHashtagRootUrl, usernamePath: customUsernamePath } = options || {};
  //   const mergedOptions = {
  //     rootUrl: customRootUrl || rootUrl,
  //     hashtagRootUrl: customHashtagRootUrl || hashtagRootUrl,
  //     usernamePath: customUsernamePath || usernamePath,
  //   };

  //   const hashtagRegex = /(#\w+)/g;
  //   const usernameRegex = /(@\w+)/g;
  //   const linkRegex = /\b(https?:\/\/\S+)/gi;
  //   const emailRegex = /\b(\w+@\w+\.\w+)\b/g;
  //   const phoneRegex = /\b(\d{3}[-.]?\d{3}[-.]?\d{4})\b/g;

  //   return text.replace(hashtagRegex, (_, hashtag) => {
  //     const hashtagUrl = `${hashtagRootUrl}/${hashtag.slice(1)}`;
  //     return `<a href="${hashtagUrl}">${hashtag}</a>`;
  //   }).replace(usernameRegex, (_, username) => {
  //     const usernameUrl = `${mergedOptions.rootUrl}/${mergedOptions.usernamePath}/${username.slice(1)}`;
  //     return `<a href="${usernameUrl}">${username}</a>`;
  //   }).replace(linkRegex, (_, link) => {
  //     return `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`;
  //   }).replace(emailRegex, (_, email) => {
  //     const mailtoLink = `mailto:${email}`;
  //     return `<a href="${mailtoLink}">${email}</a>`;
  //   }).replace(phoneRegex, (_, phone) => {
  //     const phoneLink = `tel:${phone.replace(/[-.]/, '')}`;
  //     return `<a href="${phoneLink}">${phone}</a>`;
  //   });
  // }

  getCurrentPosition() {
    let location;
    if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.ngZone.run(() => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const accuracy = position.coords.accuracy;

            location = { lat: latitude, lng: longitude, acc: accuracy};
          });
        },
        (error) => {
          this.ngZone.run(() => {            
            location = { lat: 0, lng: 0};
          });
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 60000 }
      )
    } else {
      location = { lat: 0, lng: 0};
    }

    return location;
  }

  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  confirm(message: string, okText: string = 'OK', title: string = 'Confirm'): Subject<boolean> {
    this.modalResponse$ = new Subject<boolean>();
    this.confirmModalTitle = title;
    this.confirmOkText = okText;
    this.modal = new bootstrap.Modal(document.getElementById('confirmModal'), { backdrop: 'static'});
    const confirmationMessage = document.getElementById('confirmationMessage');
    const okButton = document.getElementById('confirmOkButton');
    const titleLabel = document.getElementById('confirmModalLabel');
    if (confirmationMessage) {
      confirmationMessage.textContent = message;
    }
    if (okButton) {
      okButton.textContent = okText;
    }
    if(titleLabel) {
      titleLabel.textContent = title;
    }
    this.modal.show();
    return this.modalResponse$;
  }

  confirmAction(confirmed: boolean) {
    if (this.modalResponse$) {
      this.modalResponse$.next(confirmed);
      this.modalResponse$.complete();
      this.modal?.hide();
    }
  }

  setMinDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2);
    const day = ('0' + today.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  async copyText(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      // console.log('Text copied to clipboard');
      this.showToast('Copied to clipboard','success');
    } catch (err) {
      // console.error('Failed to copy text: ', err);
      this.showToast('Failed to copy to clipboard','success');
    }
  }
  
  getMomentsAgo(date: Date): string {
    const now = new Date();
    const diff = now.getTime() - date.getTime();

    if (diff < 60 * 1000) {
      return "now";
    } else if (diff < 60 * 60 * 1000) {
      const minutes = Math.floor(diff / (60 * 1000));
      return `${minutes}m`;
    } else if (diff < 24 * 60 * 60 * 1000) {
      const hours = Math.floor(diff / (60 * 60 * 1000));
      return `${hours}h`;
    } else if (diff < 7 * 24 * 60 * 60 * 1000) {
      const days = Math.floor(diff / (24 * 60 * 60 * 1000));
      return `${days}d`;
    } else if (date.getFullYear() === now.getFullYear()) {
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      });
    } else {
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    }
  }

  showModal(elementId: string) {
    this.closeAllOpenModals();
    const modalEl: any = document.getElementById(elementId);
    const modal = new bootstrap.Modal(modalEl, { backdrop: 'static', keyboard: true });
    if (modalEl) {
      modal.show();
    }
  }

  closeModal(elementId: string) {
    // const modalEl:any = document.getElementById(`${elementId}`);
    const modalEl = document.getElementById(`${elementId}`);
    const modal = bootstrap.Modal.getInstance(modalEl);
    if (modalEl) {
      modal.hide();
    }
  }

  closeAllOpenModals() {
    // Close all open modals first
    const openModals = document.querySelectorAll('.modal.show');
    openModals.forEach((modalEl: any) => {
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    });
  }

}
